import {createTheme, ThemeOptions} from '@mui/material/styles';
import {colors} from 'common/colors';
import {merge} from 'lodash';

declare module '@mui/material/styles' {
   interface TypographyVariants {
      label: React.CSSProperties;
   }

   // allow configuration using `createTheme`
   interface TypographyVariantsOptions {
      label?: React.CSSProperties;
   }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
   interface TypographyPropsVariantOverrides {
      label: true;
      //   h3: false;
   }
}

export const generateTheme = (theme = {} as ThemeOptions) =>
   createTheme(
      merge(
         {
            typography: {
               htmlFontSize: 12,
               fontSize: 12,
               fontFamily: [
                  '"Poppins"',
                  '"Bebas Neue"',
                  'Roboto',
                  '"Helvetica Neue"',
                  'Arial',
                  'sans-serif',
               ].join(','),
               body1: {
                  fontFamily: "'Poppins', Arial, sans-serif",
               },

               overline: {
                  lineHeight: 'inherit',
               },
               label: {
                  fontFamily: '"Poppins"',
                  fontVariant: 'all-petite-caps',
                  fontWeight: 400,
                  fontSize: '1rem',
                  lineHeight: '1.43',
                  letterSpacing: '0.01071em',
               },
            },
            zIndex: {
               drawer: 1000,
            },
            mixins: {
               toolbar: {
                  minHeight: 53,
               },
            },
            palette: {
               // mode: 'dark',
               secondary: {
                  main: '#3eabd1',
                  contrastText: '#fff',
               },
            },
            components: {
               MuiFormControl: {
                  defaultProps: {
                     margin: 'dense',
                     size: 'small',
                  },
                  styleOverrides: {
                     root: {
                        marginTop: 12,
                     },
                  },
               },
               MuiButton: {
                  defaultProps: {
                     size: 'small',
                     color: 'inherit',
                  },
                  styleOverrides: {
                     root: {
                        borderRadius: 2,
                        // marginTop: '.5rem',
                     },
                  },
               },
               MuiFilledInput: {
                  defaultProps: {
                     // margin: 'dense',
                  },
               },
               MuiFormHelperText: {
                  defaultProps: {
                     margin: 'dense',
                  },
               },
               MuiIconButton: {
                  defaultProps: {
                     size: 'small',
                  },
               },
               MuiInputBase: {
                  defaultProps: {
                     // margin: 'dense',
                     // size: 'small',
                  },
               },
               MuiInputLabel: {
                  defaultProps: {
                     margin: 'dense',
                  },
                  styleOverrides: {
                     root: {
                        fontSize: '1rem',
                        lineHeight: '1.1em',
                        letterSpacing: '0.00938em',
                        textTransform: 'uppercase',
                     },
                  },
               },
               MuiListItem: {
                  defaultProps: {
                     dense: true,
                  },
               },
               MuiOutlinedInput: {
                  defaultProps: {
                     // margin: 'dense',
                     // size: 'small',
                  },
                  styleOverrides: {
                     root: {
                        fontSize: '1rem',
                        lineHeight: '1em',
                        borderRadius: '2px',
                        '&.Mui-disabled': {
                           background: colors.lightGrey,
                           // '& input': {
                           // background: colors.lightGrey,
                           // },
                        },
                     },
                     input: {
                        padding: '6.5px 14px',
                     },
                     notchedOutline: {
                        '& > legend': {
                           textTransform: 'uppercase',
                           fontSize: '.73rem',
                        },
                     },
                  },
               },
               MuiFab: {
                  defaultProps: {
                     size: 'small',
                  },
               },
               MuiTable: {
                  defaultProps: {
                     size: 'small',
                  },
               },
               MuiTextField: {
                  defaultProps: {
                     // margin: 'dense',
                  },
               },
               MuiSelect: {
                  styleOverrides: {
                     select: {
                        lineHeight: '1.4375em',
                     },
                  },
               },
               MuiToolbar: {
                  defaultProps: {
                     variant: 'dense',
                  },
               },
               MuiDialogActions: {
                  styleOverrides: {
                     root: {
                        justifyContent: 'center',
                     },
                  },
               },
               MuiCssBaseline: {
                  styleOverrides: {
                     'a, a:hover': {
                        color: 'inherit',
                        textDecoration: 'initial',
                     },
                  },
               },
            },
         },
         theme
      )
   );
